export default __webpack_public_path__ + "static/Chicago-51756d7577c7836e0a460598b0f32b1f.webp";